import GpsFijosForm from "./GpsFijosForm";
export default GpsFijosForm;
